"use client";

import { useEffect } from "react";
import { initObservability } from "@/observability";

export function ObservabilityInitializer() {
  useEffect(() => {
    initObservability();
  }, []);

  return null;
}